import React from 'react'
import DfbHeadline from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_headline'
import DfbImage from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_image'
import DfbRte from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_rte'
import DfBButton from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_button'
import { useTranslations } from '@dfb/gatsby-dfb-theme/src/hooks/useTranslations'
import Section from '@dfb/gatsby-dfb-theme/src/components/blocks/section'

const MHeroTeaser = ({ data }) => {
  const { kicker, image, images } = data

  const t = useTranslations()

  return (
    <Section
      baseClass="m-HeroTeaser"
      className={
        data.layout === 'umbrella-branding' ? 'm-HeroTeaser--dachmarke' : data.layout === 'employer-branding' ? 'm-HeroTeaser--big' : ''
      }
      data={data}
      defaultPadding="large"
    >
      <div className="m-HeroTeaser-wrapper">
        <div className="m-HeroTeaser-container">
          {image && image.length > 0 && (
            <DfbImage image={image[0]} add_class="m-HeroTeaser-backgroundImage u-Image--xs u-Image-cover" overlay="75" />
          )}
          {images && images.length > 0 && (
            <>
              {images[0].image && images[0].image[0] && <DfbImage image={images[0].image[0]} add_class="m-HeroTeaser-foregroundImage" />}
              <div className={`m-HeroTeaser-content${images?.[0]?.image?.[0] ? '' : ' m-HeroTeaser-content--textOnly'}`}>
                {kicker && <div className="m-HeroTeaser-topline">{kicker}</div>}
                {images[0].image_headline && (
                  <DfbHeadline
                    headline={images[0].image_headline}
                    headline_level="h2"
                    add_class="c-Headline u-Theme-dark m-HeroTeaser-headline dfb-Headline--h2 dfb-Headline"
                  />
                )}
                {images[0].image_description && (
                  <DfbRte text={images[0].image_description} add_class="u-Theme-dark m-HeroTeaser-paragraph" />
                )}
                {images[0].image_link_obj?.url && (
                  <DfBButton
                    add_class="m-HeroTeaser-button u-Theme-dark"
                    link={images[0].image_link_obj?.url}
                    external={images[0].image_link_obj?.type !== 'page'}
                    text={images[0]?.image_alternative || t('dfb_anchor.readmore')}
                    tagName="a"
                  ></DfBButton>
                )}
              </div>
            </>
          )}
        </div>
        {(image?.[0]?.copyright || images?.[0]?.image?.[0]?.copyright) && (
          <div className="m-HeroTeaser-copyright" style={{ gap: '8px' }}>
            {image?.[0]?.copyright && <div>{image[0].copyright}</div>}
            {images?.[0]?.image?.[0]?.copyright && <div>{images[0].image[0].copyright}</div>}
          </div>
        )}
      </div>
    </Section>
  )
}

export default MHeroTeaser
